import {
    GroupRideMessageContract,
    GroupRideMessageSenderInfoContract,
} from '@polaris-customerweb/sharedcomponents.core';
import { RideGroupAlert } from '@polaris-customerweb/sharedcomponents.vehicle-health';
import { RideGroupRiderStatus } from './ride-group-rider-status';

export class RideGroupMessage {
    private messageDto: GroupRideMessageContract;
    private senderDto: GroupRideMessageSenderInfoContract;
    private _isCurrentUserMessage: boolean;
    private _isAlert: boolean;
    private _isCanceled: boolean;
    private _riderFeatureId: string;

    constructor(
        messageDto: GroupRideMessageContract,
        senderDto: GroupRideMessageSenderInfoContract,
        isAlert = false,
        riderFeatureId?: string
    ) {
        this.messageDto = messageDto;
        this.senderDto = senderDto;
        this._isAlert = isAlert;
        this._riderFeatureId = riderFeatureId || '';
    }

    get messageId(): string {
        return this.messageDto.messageId || '';
    }

    get name(): string {
        return this.senderDto.handle || '';
    }

    get dateSent(): Date {
        return this.messageDto.sentAt
            ? new Date(this.messageDto.sentAt)
            : new Date();
    }

    get sentAt(): number {
        return this.messageDto.sentAt || NaN;
    }

    get fromSenderId(): string {
        return this.messageDto.fromSenderId || '';
    }

    get message(): string[] {
        return this.messageDto.messageSegments || [];
    }

    get color(): string {
        return this.senderDto.color || '';
    }

    get riderId(): string {
        return this.senderDto.riderId || '';
    }

    get timestamp(): number {
        return this.messageDto.sentAt || NaN;
    }

    get relayedBySenderId(): string {
        return this.messageDto.relayedBySenderId || '';
    }

    get isCurrentUserMessage(): boolean {
        return this._isCurrentUserMessage;
    }

    set isCurrentUserMessage(val: boolean) {
        this._isCurrentUserMessage = val;
    }

    get riderFeatureId(): string {
        return this._riderFeatureId;
    }

    get isAlert(): boolean {
        return this._isAlert;
    }

    get isCanceled(): boolean {
        return this._isCanceled;
    }

    set isCanceled(val: boolean) {
        this._isCanceled = val;
    }

    static fromAlert(
        alert: RideGroupAlert,
        rider: RideGroupRiderStatus | undefined,
        canceled = false
    ) {
        return new RideGroupMessage(
            {
                fromSenderId: alert.riderId,
                messageSegments: [
                    canceled ? 'Canceled Help Alert' : 'Help Alert',
                ],
                sentAt: Date.now(),
            },
            {
                color: rider?.color,
                handle: rider?.handle,
                riderId: rider?.riderId,
                senderId: rider?.riderId,
            },
            true,
            alert.riderFeatureId
        );
    }
}
